// src/theme.ts
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FC6934", // deporte.primary
      light: "#FCE8E5", // deporte.p100
      dark: "#F34900", // deporte.p700
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#D6FF59", // actividad.primary
      light: "#F9FFE9", // actividad.p100
      dark: "#C3EA2C", // aproximación para actividad.p700
      contrastText: "#000000",
    },
    error: {
      main: "#E80000", // errors.primary
    },
    background: {
      default: "#FCFCFC", // bg
    },
    text: {
      primary: "#1A1A19", // neutros.primaryDark
      secondary: "#575759", // neutros.p700
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: "98px", fontWeight: 500 },
    h2: { fontSize: "62px", fontWeight: 300 },
    h3: { fontSize: "50px", fontWeight: 400 },
    h4: { fontSize: "36px", fontWeight: 400 },
    h5: { fontSize: "26px", fontWeight: 500 },
    h6: { fontSize: "22px", fontWeight: 500 },
    subtitle1: { fontSize: "22px", fontWeight: 400 },
    subtitle2: { fontSize: "18px", fontWeight: 500 },
    body1: { fontSize: "18px", fontWeight: 400 },
    body2: { fontSize: "16px", fontWeight: 300 },
    button: { fontSize: "12px", fontWeight: 700 },
    caption: { fontSize: "14px", fontWeight: 400 },
    overline: { fontSize: "12px", fontWeight: 400 },
  },
  shape: {
    borderRadius: 22,
  },
});

export default theme;
